function maxSize(text, size) {
  if (!text || text.length <= size) return text
  return text.slice(0, size) + '...'
}

export { maxSize }
